import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useAuth } from './auth/cognito.js';
import Layout from './components/Layout.jsx';
import BuilderView from './views/BuilderView.jsx';
import DiffView from './views/DiffView.jsx';
import PersonasView from './views/PersonasView.jsx';
import SpecsView from './views/SpecsView.jsx';
import AuthCallbackView from './views/AuthCallbackView.jsx';

function getView(pathname) {
  if (pathname === '/auth/callback') return 'auth/callback';
  if (pathname === '/diff') return 'diff';
  if (pathname === '/personas') return 'personas';
  if (pathname === '/specs') return 'specs';
  return 'builder';
}

export default function App() {
  const [pathname, setPathname] = useState(window.location.pathname);
  const [header, setHeader] = useState({ specLabel: '', profileName: '' });
  const { isAuthenticated, login } = useAuth();

  const navigate = useCallback((path) => {
    history.pushState(null, '', path);
    setPathname(path);
  }, []);

  useEffect(() => {
    const onPop = () => setPathname(window.location.pathname);
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  const view = getView(pathname);

  if (view !== 'auth/callback' && !isAuthenticated) {
    return (
      <div className="cb-signin">
        <div className="card">
          <div className="cb-logo" style={{ margin: '0 auto 12px' }} />
          <h1>CSS Profile Decision-Tree Tester</h1>
          <p>Sign in with your College Board account to continue.</p>
          <button onClick={login} className="cb-btn primary" style={{ width: '100%' }}>Sign in</button>
        </div>
      </div>
    );
  }

  return (
    <Layout
      navigate={navigate}
      currentView={view}
      specLabel={header.specLabel}
      profileName={header.profileName}
      fullBleed={view === 'builder'}
    >
      {view === 'auth/callback' && <AuthCallbackView navigate={navigate} />}
      {view === 'builder' && <BuilderView setHeader={setHeader} />}
      {view === 'diff' && <DiffView />}
      {view === 'personas' && <PersonasView navigate={navigate} />}
      {view === 'specs' && <SpecsView />}
    </Layout>
  );
}
